import { render, staticRenderFns } from "./PartTypeList.vue?vue&type=template&id=136614e2"
import script from "./PartTypeList.vue?vue&type=script&lang=js"
export * from "./PartTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports